var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Public-Slider"},[_c('i',{staticClass:"fa fa-star-half-empty"}),_c('div',{staticClass:"MoveTop",on:{"click":_vm.MoveTop}},[_c('i',{staticClass:"fa fa-angle-double-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }